import styled from 'styled-components'

import { Text } from 'components/Text/Text'

export const FacilitiesGrid = styled.div`
  display: grid;
  grid-template: 1fr / repeat(3, 1fr);
  grid-gap: 2rem;
  margin: 0 0 3rem;
`

export const FacilitiesTitleSection = styled(Text)`
  margin: 0 0 3rem;
`
export const FacilitiesItem = styled.div`
  text-align: center;
`
export const FacilitiesImage = styled.img`
  margin: 0 0 1rem;
`
export const FacilitiesTitle = styled(Text)`
  margin: 0 0 1rem;
`
export const FacilitiesText = styled(Text)`
  line-height: 1.625rem;
`
export const FacilitiesActions = styled.div`
  display: flex;
  justify-content: center;
`
export const FacilitiesLink = styled(Text)`
  font-size: 1.125rem;
  line-height: 1.125rem;
`
